export default "__VITE_ASSET__GewP4UkJ__"